<div class="ap-margin-bottom-3">
    {{ 'extra-asset.mortgage-amount.amount' | coApplicantPipe: store.hasCoApplicant | apContent }}
</div>

<ap-amount-input
    id="mortgageAmount"
    [helpText]="'extra-asset.mortgage-amount.help-text' | apContent"
    [showSymbol]="true"
    [numberOfDecimals]="0"
    [formControl]="mainApplicantControl"
></ap-amount-input>

<additional-info
    [key]="questionKey"
    titleKey="extra-asset.mortgage-amount.amount.additional-info.text"
    contentKey="extra-asset.extra-asset.mortgage-amount.amount.additional-info.content"
    modalUrlKey="extra-asset.mortgage-amount.amount.additional-info.text"
></additional-info>

@if (!store.isSummary) {
    <next-button (click)="nextQuestion()"></next-button>
}
